import { createAsyncThunk } from "@reduxjs/toolkit";
import { getNotifications as getNotificationApi ,changeStatusNotification as changeStatusNotificationApi} from "../../apiCalls/caller";

export const getNotifications = createAsyncThunk(
  "notifications/getNotifications",
  async (data) => {
    try {
      const response = getNotificationApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);

export const changeStatusNotification = createAsyncThunk(
  "notifications/changeStatus",
  async (data) => {
    try {
      const response = changeStatusNotificationApi(data);
      return response;
    } catch (error) {
      return error;
    }
  }
);
